"use client"

import styles from "../../index.module.scss"
import { useSuffix } from "../../SuffixContext"
import { AdComponentTypes } from "../../types"
import { getPrefixCls } from "../../utils"

const prefixCls = getPrefixCls("ADComponent")

export default function OneImg(props: AdComponentTypes) {
  const suffix = useSuffix()
  const { AdList, style } = props
  return (
    <div className={`${prefixCls} ${styles.oneImg}`} style={style}>
      <ul>
        {AdList.adverts.map((item, index) => {
          if (index === 0) {
            return (
              <li key={index} className={styles.oneImgLi} data-sort={item.sort_score}>
                <a href={item.link_url} className={styles.oneImgA} target="_blank" rel="noreferrer">
                  <img
                    src={`${item.pic_url}${suffix || ""}`}
                    alt={item.name}
                    loading="lazy"
                    style={{
                      width: AdList.len,
                      height: AdList.width,
                      margin: "0 auto",
                    }}
                  />
                </a>
                {item.is_inner === 0 && (
                  <div key={index} className={styles.oneImgSub}>
                    AD
                  </div>
                )}
              </li>
            )
          }
        })}
      </ul>
    </div>
  )
}
